import { graphql } from "gatsby"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import * as React from "react"
import {
  Base, FeatureText, Link, Subhead
} from "./ui"
import * as styles from "./ui.css"

const FeatureItem = (props) => {
  return (
    <Base as="div" cx={[styles.featureIconOuter]}>
      {props.image && (
        <Base
          as={GatsbyImage}
          cx={[styles.featureIcon]}
          alt={props.image.alt}
          image={getImage(props.image.gatsbyImageData)}
        />
      )}
      {props.children}
    </Base>
  )
}

export default function Feature({ first, last, ...props }) {
  return (
    <Base as="div" cx={[first ? styles.firstProductsItem : last ? styles.lastProductsItem : styles.productsItem]} style={{ backgroundColor: props.secondColor }}>
      <Base as="div" cx={[styles.productTitle]} style={{ backgroundColor: props.primaryColor }}>
        <FeatureItem image={props.image}>
          <Subhead>
            {props.heading}
          </Subhead>
        </FeatureItem>
      </Base>
      <FeatureText>{props.text}</FeatureText>
      <Base as="div" className={[styles.brandImages]}>
        <div style={{ flex: 1 }} />
        {props.links && props.links.map((item, i) => {
          return item.brand && (
            <Link to={item.href} target="_blank">
              <Base
                as={GatsbyImage}
                placeholder='none'
                alt={item.brand.alt}
                image={getImage(item.brand.gatsbyImageData)}
                className={[(i == 0) ? styles.brandImageFirst : styles.brandImage]}
              />
            </Link>
          );
        })}
        <div style={{ flex: 1 }} />
      </Base>
    </Base>
  )
}

export const query = graphql`
  fragment HomepageFeatureContent on HomepageFeature {
    id
    kicker
    heading
    text
    primaryColor
    secondColor
    links {
      id
      href
      text
      brand {
        id
        gatsbyImageData
        alt
      }
    }
    image {
      id
      gatsbyImageData
      alt
    }
  }
`
